// extracted by mini-css-extract-plugin
module.exports = {"singleAdmin":"SingleAdmin_singleAdmin__1fz4V","adminName":"SingleAdmin_adminName__z0O9P","gymAccess":"SingleAdmin_gymAccess__36neq"};